export default function Fedipact() {
    return (
        <div className="my-2">
            <div className="bg-black bg-opacity-30 p-3 text-purple-100 text-base sm:text-lg">
                <p>I believe that Facebook represents one of the gravest threats to democracies around the world, and I am amazed that we have allowed our freedoms to be taken away by technology companies’ greed for growth and revenues.</p>
                <p className="ml-2 my-2 text-sm sm:text-base">- Maria Ressa, <span className="italic">How to Stand Up to a Dictator</span>, 2022</p>
            </div>
        </div>
    )
}